module.exports = __webpack_public_path__ + "img/product_index_icon4.f9966628.png";